import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PermissionListSearchCriteria } from '../../pages/roles/models/permission-list.model';
import { PermissionViewDto } from '../../pages/roles/models/permission-view.model';
import { RoleMasterResponse } from '../models';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class PermissionsService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.permission;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getPermission(): Observable<RoleMasterResponse[]> {
    return this.http.get<RoleMasterResponse[]>(this.getUrl(), {
      headers: this.headers,
      observe: 'body'
    });
  }

  findPermissions(criteria: PermissionListSearchCriteria): Observable<any> {
    const params = this.getParams(criteria);
    return this.http.get<any>(this.getFullUrl(this.envService.list), {
      params,
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getPermissionByCode(code: string): Observable<PermissionViewDto> {
    return this.http.get<PermissionViewDto>(this.getFullUrl(this.envService.view, { code }), {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  removePermissionFromRole(code: string, roleNo: string): Observable<void> {
    return this.http.delete<void>(
      this.getFullUrl(this.envService.remove, { code, roleNo }, false, this.env.services.role.url),
      {
        headers: this.loaderHeaders(),
        observe: 'body'
      }
    );
  }
}
